import React from "react";
import { User, MessageSquareText, MessageCircle, PhoneCall, Cpu, Database, BarChart3, ArrowRight, ArrowDown } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";

const Node = ({ icon: Icon, title, sub, tone = "default" }) => {
  const tones = {
    default: "bg-white border-slate-200 text-slate-900",
    primary: "bg-[var(--et-navy)] border-transparent text-white",
    accent: "bg-[rgba(37,99,235,0.06)] border-[rgba(37,99,235,0.2)] text-slate-900",
  };
  return (
    <div className={`rounded-2xl border px-4 py-3 shadow-sm flex items-center gap-3 ${tones[tone]}`}>
      <span className={`flex h-9 w-9 items-center justify-center rounded-xl ${tone === "primary" ? "bg-white/10 text-[var(--et-accent)]" : "bg-[rgba(37,99,235,0.1)] text-[var(--et-primary)]"}`}>
        <Icon className="h-4 w-4" />
      </span>
      <div className="text-left">
        <div className={`text-sm font-semibold ${tone === "primary" ? "text-white" : "text-slate-900"}`}>{title}</div>
        {sub && <div className={`text-[11px] ${tone === "primary" ? "text-slate-300" : "text-slate-500"}`}>{sub}</div>}
      </div>
    </div>
  );
};

const HArrow = () => <ArrowRight className="hidden lg:block h-5 w-5 text-slate-300 shrink-0" />;
const VArrow = () => <ArrowDown className="lg:hidden h-5 w-5 text-slate-300" />;

/**
 * Combined communication flow: Customer -> Channels -> Automation Engine -> CRM -> Analytics.
 */
export const FlowDiagram = () => {
  return (
    <Reveal className="et-card p-6 sm:p-8" data-testid="combined-communication-flow">
      <div className="flex flex-col lg:flex-row items-center lg:items-stretch justify-center gap-4 lg:gap-3">
        <div className="flex flex-col justify-center"><Node icon={User} title="Customer" sub="Inbound / outbound" /></div>
        <div className="flex items-center justify-center"><HArrow /><VArrow /></div>

        <div className="flex flex-col gap-2 justify-center">
          <Node icon={MessageSquareText} title="WhatsApp" tone="accent" />
          <Node icon={MessageCircle} title="SMS" tone="accent" />
          <Node icon={PhoneCall} title="Voice" tone="accent" />
        </div>
        <div className="flex items-center justify-center"><HArrow /><VArrow /></div>

        <div className="flex flex-col justify-center"><Node icon={Cpu} title="Automation Engine" sub="Rules & workflows" tone="primary" /></div>
        <div className="flex items-center justify-center"><HArrow /><VArrow /></div>

        <div className="flex flex-col gap-2 justify-center">
          <Node icon={Database} title="CRM / Business System" sub="Sync & records" />
          <Node icon={BarChart3} title="Analytics" sub="Insights & reports" />
        </div>
      </div>
    </Reveal>
  );
};
